import React, { FC, useRef } from 'react';

import {
  FormLabel,
  FormControl,
  FormHelperText,
} from '@chakra-ui/form-control';
import { Text } from '@chakra-ui/layout';
import { Input, InputRightElement } from '@chakra-ui/input';

import { MdCalendarToday } from 'react-icons/md';

import { useField, useFormikContext } from 'formik';

import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

import { FormikDatepickerProps } from './FormikDatepicker.props';
import './FormikDatepicker.style.css';
import { convertUTCToLocal } from 'utils/dateUtils';
import moment from 'moment';
const FormikDatepickerView: FC<
  FormikDatepickerProps & { onDateChange?: (date: String | null) => void }
> = ({
  name,
  label,
  error,
  labelProps,
  helperText,
  isEditable,
  isRequired,
  containerProps,
  onDateChange,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [{ value }, meta, helpers] = useField(name);

  // const displayValue = !!value ? moment.utc(value).format('MM/DD/YYYY') : '';

  // const selected = !!value ? moment.utc(displayValue).toDate() : null;

  const { setFieldTouched } = useFormikContext<any>();

  // const moreProps = isEditable
  //   ? {
  //       onSelect: (date: Date | null) => {
  //         if (inputRef.current && inputRef.current?.value && !!date) {
  //           inputRef.current.value = moment.utc(date).format('MM/DD/YYYY');
  //         }
  //       },
  //       onChangeRaw: (e: React.FocusEvent<HTMLInputElement, Element>) => {
  //         const newRaw = moment(e.target.value, 'MM/DD/YYYY', true)
  //           .startOf('day')
  //           .toDate();
  //         if (newRaw instanceof Date && !isNaN(newRaw as any)) {
  //           helpers.setValue(newRaw);
  //           if (inputRef.current) {
  //             inputRef.current.value = moment(newRaw).format('MM/DD/YYYY');
  //           }
  //         }
  //       },
  //     }
  //   : {};

  return (
    <FormControl mt={3} isRequired={isRequired} {...containerProps}>
      {label && (
        <FormLabel htmlFor={name} {...labelProps} textTransform="capitalize">
          {label}
        </FormLabel>
      )}

      <DatePicker
        wrapperClassName="formik-datepicker"
        toggleCalendarOnIconClick
        disabled={props.disabled || false}
        showIcon
        icon={
          <InputRightElement>
            <MdCalendarToday fill="#2FB64A" />
          </InputRightElement>
        }
        selected={value}
        dateFormat="MM/dd/yyyy"
        onBlur={() => setFieldTouched(name, true)}
        onChange={(date) => {
          const day = date?.getDate()?.toString().padStart(2, '0');
          // adding 1 to the month because javascript months are 0 based index
          const month = (date?.getMonth()! + 1).toString().padStart(2, '0');
          const year = date?.getFullYear();

          const dateString = `${month}/${day}/${year}`;

          helpers.setValue(dateString);

          onDateChange?.(dateString);

          // helpers.setValue(moment.utc(dateString).format('YYYY-MM-DD'));
          // onDateChange?.(moment.utc(dateString).format('YYYY-MM-DD'));
          // if (onDateChange) {
          //   let functionDateData = dateResponse
          //     ? moment(dateResponse).format('YYYY-MM-DD')
          //     : null;
          //   onDateChange(functionDateData);
          // }
        }}
        customInput={
          <Input
            ref={inputRef}
            id="date-picker-input"
            isReadOnly={!isEditable}
            bg={props.readOnly ? '#DEDCDC' : 'inputColor'}
          />
        }
        {...props}
        // {...moreProps}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {(error || meta.error) && meta.touched && (
        <Text color="red.500" fontSize="sm">
          {meta.error || error}
        </Text>
      )}
    </FormControl>
  );
};

export default FormikDatepickerView;
